<template>
  <div class="exinformation">
    <div class="title">
      展商资料
      <p></p>
    </div>
    <div class="register_1">
      <el-form
        class="register-form"
        ref="register1_Form"
        :model="form"
        label-width="0px"
        :rules="rules"
      >
        <el-form-item style="margin: 45px 0 60px 0;">
          <div class="lxr">
            <p>联系人信息</p>
            <p>
              <span>*</span>
              为必填项
            </p>
          </div>
        </el-form-item>

        <el-form-item label="姓名：" label-width="161px" prop="pName">
          <el-input :disabled="initInputStatus" v-model="form.pName" placeholder="请填写姓名"></el-input>
        </el-form-item>

        <el-form-item label="职务：" label-width="161px" prop="pJob">
          <el-input :disabled="initInputStatus" v-model="form.pJob" placeholder="请填写职务"></el-input>
        </el-form-item>

        <el-form-item label="座机：" label-width="161px">
          <el-input :disabled="initInputStatus" v-model="form.pLandline" placeholder="请输入座机号"></el-input>
        </el-form-item>

        <el-form-item label="邮箱：" label-width="161px" prop="pEmail">
          <el-input :disabled="initInputStatus" v-model="form.pEmail" placeholder="请填写邮箱（包括@及域名）"></el-input>
        </el-form-item>

        <el-form-item style="margin: 43px 0 36px 0;">
          <div class="lxr">
            <p>企业信息</p>
            <p>
              <span>*</span>
              为必填项
            </p>
          </div>
        </el-form-item>

        <el-form-item label="公司名称：" label-width="161px" prop="cName">
          <el-input :disabled="initInputStatus" v-model="form.cName" placeholder="请填写营业执照上的企业公司名称"></el-input>
        </el-form-item>

        <el-form-item label="公司名称(英文)：" label-width="161px">
          <el-input :disabled="initInputStatus" v-model="form.cEnglishName" placeholder="请填写公司名称"></el-input>
        </el-form-item>

        <el-form-item label="营业执照：" label-width="161px" prop="cLicense">
          <el-upload
            class="upload-demo"
            :action="uploadAction"
            :on-remove="cLicenseHandleRemove"
            :before-remove="beforeRemove"
            :on-success="cLicenseSuccess"
            multiple
            :limit="1"
            :file-list="fileList"
            :on-exceed="handleExceed"
            v-if="initRadioAndUploadImg"
          >
            <el-button>上传高清图</el-button>
            <div slot="tip" class="el-upload__tip">清晰的图片可以让您更快通过审核；</div>
            <div slot="tip" class="el-upload__tip">推荐上传扫描件，拍照请尽量减低反光；</div>
            <div slot="tip" class="el-upload__tip">请确保营业执照图片所有信息清晰可见，内容真实有效，无任何修改；</div>
            <div slot="tip" class="el-upload__tip">文件袋洗啊不超过8M，格式支持.jpg .jpeg .bmp .png .pdf</div>
          </el-upload>
          <img v-else :src="$getSrc(initImg.licenseImg)" alt crossorigin class="zhanshiLicenseImg" />
        </el-form-item>

        <el-form-item label="公司logo：" label-width="161px" prop="cLogo">
          <el-upload
            class="avatar-uploader"
            :action="uploadAction"
            :show-file-list="false"
            :on-success="cLogoHandleAvatarSuccess"
            :before-upload="cLogoBeforeAvatarUpload"
            v-if="initRadioAndUploadImg"
          >
            <img v-if="logoImageUrl" :src="$getSrc(logoImageUrl)" crossorigin class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip rihtDpi">建议分辨率：200-300dpi</div>
          </el-upload>
          <img v-else :src="$getSrc(initImg.logoImg)" alt crossorigin class="zhanshiLogoImg" />
        </el-form-item>

        <el-form-item label="详细地址：" label-width="161px" prop="cAddress">
          <el-input :disabled="initInputStatus" v-model="form.cAddress" placeholder="请填写详细地址"></el-input>
        </el-form-item>

        <el-form-item label="地址(英文)：" label-width="161px">
          <el-input :disabled="initInputStatus" v-model="form.cEnglishAddres"></el-input>
        </el-form-item>

        <el-form-item label="网址：" label-width="161px">
          <el-input :disabled="initInputStatus" v-model="form.cWebsite">
            <template slot="prepend">http://</template>
            <template slot="append">.com</template>
          </el-input>
        </el-form-item>

        <el-form-item label="企业类型：" label-width="161px" prop="cType">
          <el-radio-group v-model="form.cType" @change="cTypeRadio" v-if="initRadioAndUploadImg">
            <el-radio :label="'国营企业'">国营企业</el-radio>
            <el-radio :label="'集体企业'">集体企业</el-radio>
            <el-radio :label="'民营企业'">民营企业</el-radio>
            <el-radio :label="'上市公司'">上市公司</el-radio>
            <el-radio :label="'中外合资'">中外合资</el-radio>
            <el-radio :label="'外商独资'">外商独资</el-radio>
            <el-radio :label="'其他'">
              其他
              <el-input
                v-model="form.cType_qit"
                :disabled="cType_qita"
                class="radio_input"
                placeholder="备注"
              ></el-input>
            </el-radio>
          </el-radio-group>
          <p v-else class="zhanshiText">{{ initImg.type }}</p>
        </el-form-item>

        <el-form-item label="运作模式：" label-width="161px" prop="cRun">
          <el-radio-group v-model="form.cRun" @change="cRunRadio" v-if="initRadioAndUploadImg">
            <el-radio :label="'生产商'">生产商</el-radio>
            <el-radio :label="'经销商'">经销商</el-radio>
            <el-radio :label="'集成商'">集成商</el-radio>
            <el-radio :label="'品牌商'">品牌商</el-radio>
            <el-radio :label="'代理商'">代理商</el-radio>
            <el-radio :label="'出版商'">出版商</el-radio>
            <el-radio :label="'其他'">
              其他
              <el-input
                v-model="form.cRun_qit"
                :disabled="cRun_qita"
                class="radio_input"
                placeholder="备注"
              ></el-input>
            </el-radio>
          </el-radio-group>
          <p v-else class="zhanshiText">{{ initImg.run }}</p>
        </el-form-item>

        <el-form-item label="注册资本：" label-width="161px" prop="cMary">
          <el-input
            :disabled="initInputStatus"
            v-model="form.cManey"
            class="zczb"
            placeholder="请填写注册资本"
          ></el-input>(万元)
        </el-form-item>

        <el-form-item label="法人代表：" label-width="161px" prop="cPerson">
          <el-input
            :disabled="initInputStatus"
            v-model="form.cPerson"
            class="zczb"
            placeholder="请填写法人代表"
          ></el-input>
        </el-form-item>

        <el-form-item label="成立年份：" label-width="161px" prop="cYear">
          <el-date-picker
            :disabled="initInputStatus"
            @change="cYearDate"
            class="clnf"
            v-model="form.cYear"
            type="year"
            value-format="yyyy"
            placeholder="请选择"
          ></el-date-picker>年
        </el-form-item>

        <el-form-item label="员工规模：" label-width="161px" prop="cPeoples">
          <el-select
            v-model="form.cPeoples"
            placeholder="请选择员工规模"
            @change="cPeoplesSelect"
            v-if="initRadioAndUploadImg"
          >
            <el-option
              v-for="item in cPeoplesOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <p v-else class="zhanshiText">{{ initImg.peoples }}</p>
        </el-form-item>

        <el-form-item label="公司简介：" label-width="161px" class="posi" prop="cIntroduction">
          <el-input
            :disabled="initInputStatus"
            class="gsjj"
            type="textarea"
            placeholder="请输入介绍信息"
            maxlength="300"
            show-word-limit
            v-model="form.cIntroduction"
          ></el-input>
        </el-form-item>

        <el-form-item label="公司简介(英文)：" label-width="161px" class="posi">
          <el-input
            :disabled="initInputStatus"
            class="gsjj"
            type="textarea"
            placeholder="请输入介绍信息"
            maxlength="300"
            show-word-limit
            v-model="form.cEnglishIntroduction"
          ></el-input>
        </el-form-item>

        <el-form-item label="参展状态：" label-width="161px" prop="cExhibition">
          <el-select
            v-model="form.cExhibition"
            class="czzt"
            placeholder="请选择近三年是否参加北京教育装备展"
            @change="cExhibitionSelect"
            :disabled="initInputStatus"
            v-if="initRadioAndUploadImg"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="form.cExhibition_child"
            class="czzt_2"
            placeholder="展会类型"
            @change="cExhibitionChildSelect"
            :disabled="initInputStatus"
            v-if="initRadioAndUploadImg"
          >
            <el-option
              v-for="item in optionsChild"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <p v-else class="zhanshiText">{{ initImg.exhibition }}</p>
        </el-form-item>

        <el-form-item label="主营产品类型：" label-width="161px" prop="cProduct">
          <el-select
            v-model="form.cProduct"
            class="yggm_type"
            placeholder="请选择类型"
            @change="cProductSelect"
            v-if="initRadioAndUploadImg"
          >
            <el-option
              v-for="item in cProductOptions"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="form.cProduct_child"
            class="yggm_ly"
            placeholder="请选择所属领域"
            multiple
            @change="cProductChildSelect"
            v-if="initRadioAndUploadImg"
          >
            <el-option
              v-for="item in cProduct_childOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <div style="display: inline-block" @click="clickCheckbox">
                <el-checkbox style="margin-right:11px;" v-model="item.isCheck"></el-checkbox>
              </div>
              <span>{{ item.label }}</span>
            </el-option>
            <div style="height: 45px;background-color: #fafafa;margin-bottom: 6px;">
              <el-checkbox @change="handleChecbox" style="margin-left: 20px;">其他</el-checkbox>
              <el-input
                :disabled="checkSelect_qita"
                v-model="checkSelect_qita_input"
                class="select_qita"
                style="width:320px;height:30px;"
              ></el-input>
            </div>
          </el-select>
          <p v-else class="zhanshiText">{{ initImg.product }}</p>
        </el-form-item>

        <el-form-item label="公众号二维码：" label-width="161px" class="cqr" prop="cQr">
          <el-upload
            class="avatar-uploader qrcode"
            :action="uploadAction"
            :show-file-list="false"
            :on-success="cQrHandleAvatarSuccess"
            :before-upload="cQrBeforeAvatarUpload"
            v-if="initRadioAndUploadImg"
          >
            <img v-if="cqrImageUrl" :src="$getSrc(cqrImageUrl)" crossorigin class="avatar_qrcode" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <img v-else :src="$getSrc(initImg.qrImg)" alt crossorigin class="zhanshiLogoImg" />
        </el-form-item>
        <el-button class="next" @click="onNext(2)">{{ initInputStatus ? "编辑" : "保存" }}</el-button>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    // 邮箱校验规则
    let emailValidata = (rule, value, callback) => {
      let emailTest = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!emailTest.test(value)) {
        callback(new Error("请输入正确的邮箱!"));
      } else {
        callback();
      }
    };
    return {
      initInputStatus: true, // 初始化时只展示信息，全部禁用
      initRadioAndUploadImg: false, // 控制初始化时显示单选、上传功能还是后台获取的单选结果和已上传的图片
      cType_qita: true, // 企业类型其他
      cRun_qita: true, // 运作模式其他
      fileList: [], // 营业执照，可以上传多个，这里设置为1个
      form: {
        id: "",
        //联系人信息
        pName: "", // 姓名
        pJob: "", // 职位
        pLandline: "", // 座机
        pEmail: "", // 邮箱
        // 企业信息
        cName: "", // 公司名称
        cEnglishName: "", // 公司名称（英文）
        cLicense: "", // 营业执照
        cLogo: "", // 公司logo
        cAddress: "", // 详细地址
        cEnglishAddres: "", // 地址（英文）
        cWebsite: "", // 网址
        cType: "", // 企业类型
        cType_qit: "",
        cRun: "", // 运作模式
        cRun_qit: "",
        cManey: "", // 注册资本
        cPerson: "", // 法人代表
        cYear: "", // 成立年份
        cPeoples: "", // 员工规模
        cIntroduction: "", // 公司简介
        cEnglishIntroduction: "", // 公司简介（英文）
        cExhibition: "", // 参展状态
        cExhibition_child: "",
        cProduct: "", // 产品类型
        cProduct_child: [],
        cQr: "", // 二维码
        username: "", // 用户名
        mobile: "", // 手机号
        password: "", // 密码
        confirmPassword: "",
        code: "", // 手机验证码
        codeId: "",
        regCode: "", // 公众号验证码
      },
      // 产品类型多选下拉input
      checkSelect_qita_input: "",
      checkSelect_qita: true,
      rules: {
        pName: [{ required: true, message: "*为必填项", trigger: "blur" }], // validator 校验规则
        pJob: [{ required: true, message: "*为必填项", trigger: "blur" }],
        pEmail: [
          {
            required: true,
            validator: emailValidata,
            trigger: "blur",
          },
        ],
        cName: [{ required: true, message: "*为必填项", trigger: "blur" }],
        cLicense: [{ required: true, message: "*为必填项", trigger: "blur" }],
        cLogo: [{ required: true, message: "*为必填项", trigger: "blur" }],
        cAddress: [{ required: true, message: "*为必填项", trigger: "blur" }],
        cType: [{ required: true, message: "*为必填项", trigger: "change" }],
        cRun: [{ required: true, message: "*为必填项", trigger: "change" }],
        cManey: [{ required: true, message: "*为必填项", trigger: "blur" }],
        cPerson: [{ required: true, message: "*为必填项", trigger: "blur" }],
        cYear: [{ required: true, message: "*为必填项", trigger: "change" }],
        cPeoples: [{ required: true, message: "*为必填项", trigger: "change" }],
        cIntroduction: [
          { required: true, message: "*为必填项", trigger: "blur" },
        ],
        cExhibition: [
          { required: true, message: "*为必填项", trigger: "change" },
        ],
        cProduct: [{ required: true, message: "*为必填项", trigger: "change" }],
        cQr: [{ required: true, message: "*为必填项", trigger: "blur" }],
      },
      // 图片上传路径
      uploadAction: this.$http.adornUrl(`/fileupload/upload`),
      logoImageUrl: "",
      cqrImageUrl: "",
      // 员工规模
      cPeoplesOptions: [
        {
          value: "1-50人",
          label: "1-50人",
        },
        {
          value: "51-100人",
          label: "51-100人",
        },
        {
          value: "101-500人",
          label: "101-500人",
        },
        {
          value: "500人以上",
          label: "500人以上",
        },
      ],
      // 产品类型一级
      cProductOptions: [],
      // 产品类型二级
      cProduct_childOptions: [],
      // 一级产品类型id
      parentTypeId: 0,
      // 二级产品类型id
      childTypeId: [],

      productList: [], // 获取的产品类型list

      // 参展状态一级
      options: [],
      // 参展状态二级
      optionsChild: [],
      statusList: [],
      value: "",
      initImg: {
        qrImg: "", // 初始化时的二维码
        peoples: "", // 初始化时的员工规模
        run: "", // 初始化时的运作模式
        type: "", // 初始化时的企业类型
        exhibition: "", // 初始化时的参展状态
        product: "", // 初始化时的产品类型
        licenseImg: "", // 初始化时的营业执照
        logoImg: "",
      },
    };
  },
  mounted() {
    this.getProduct();
    this.getStatus();
    this.eventUserInfo();
  },
  methods: {
    // 当前用户信息
    eventUserInfo() {
      this.$http
        .get("userInfo")
        .then((response) => {
          let { code, user } = response.data;
          if (code === 0 && user) {
            this.form.id = user.id;
            this.form.pName = user.pName;
            this.form.pJob = user.pJob;
            this.form.pLandline = user.pLandline;
            this.form.pEmail = user.pEmail;
            this.form.cName = user.cName;
            this.form.cEnglishName = user.cEnglishName;
            this.initImg.licenseImg = user.cLicense;
            this.initImg.logoImg = user.cLogo;
            this.form.cAddress = user.cAddress;
            this.form.cEnglishAddres = user.cEnglishAddres;
            this.form.cWebsite = user.cWebsite;
            this.initImg.type = user.cType;
            this.initImg.run = user.cRun;
            this.form.cManey = user.cManey;
            this.form.cPerson = user.cPerson;
            this.form.cYear = user.cYear;
            this.initImg.peoples = user.cPeoples;
            this.form.cIntroduction = user.cIntroduction;
            this.form.cEnglishIntroduction = user.cEnglishIntroduction;
            this.initImg.exhibition = user.cExhibition;
            this.initImg.product = user.productNameList.join(",");
            this.initImg.qrImg = user.cQr;
          } else {
            this.$message.error("登录失效，请重新登录");
            this.$router.push("/login");
          }
        })
        .catch((err) => {
          this.$message.error("登录失效，请重新登录");
          this.$router.push("/login");
        });
    },
    // 获取产品类型
    getProduct() {
      this.$http({
        url: "getProduct",
        method: "post",
      })
        .then((data) => {
          let { productList } = data.data;
          this.productList = productList;
          let arr = [];
          productList.forEach((res, index) => {
            arr[index] = {
              label: res.name,
              value: res.id,
            };
          });
          this.cProductOptions = arr;
        })
        .catch((err) => {
          this.$message.error("登录失效，请重新登录");
          this.$router.push("/login");
        });
    },
    // 防止CheckBox向上emit(二级产品类型会触发一级的change事件)
    clickCheckbox(e) {
      e.preventDefault();
    },
    // 获取参展状态
    getStatus() {
      this.$http({
        url: "getStatus",
        method: "post",
      })
        .then((data) => {
          let { statusList } = data.data;
          this.statusList = statusList;
          let arr = [];
          statusList.forEach((res, index) => {
            arr[index] = {
              label: res.sta,
              value: res.sta,
            };
          });
          this.options = arr;
        })
        .catch((err) => {
          this.$message.error("登录失效，请重新登录");
          this.$router.push("/login");
        });
    },

    // 删除营业执照(文件列表移除文件时的钩子)
    cLicenseHandleRemove(file, fileList) {},
    // 营业执照文件上传成功
    cLicenseSuccess(file, fileList) {
      this.form.cLicense = file.data.url;
    },
    // 删除营业执照之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 限制营业执照上传个数
    handleExceed(files, fileList) {
      this.$message.warning("营业执照只能上传一个");
    },

    // logo上传成功
    cLogoHandleAvatarSuccess(res, file) {
      // this.logoImageUrl = URL.createObjectURL(file.raw);
      this.logoImageUrl = res.data.url;

      this.form.cLogo = res.data.url;
    },
    // logo上传之前
    cLogoBeforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 2MB!");
      // }
      // return isJPG && isLt2M;
    },
    // 二维码上传成功
    cQrHandleAvatarSuccess(res, file) {
      // this.cqrImageUrl = URL.createObjectURL(file.raw);
      this.cqrImageUrl = res.data.url;
      this.form.cQr = res.data.url;
    },
    // 二维码上传之前
    cQrBeforeAvatarUpload(file) {},

    // 企业类型单选
    cTypeRadio(val) {
      if (val === "其他") {
        this.cType_qita = false;
      } else {
        this.cType_qita = true;
      }
    },
    // 运作模式单选
    cRunRadio(val) {
      if (val === "其他") {
        this.cRun_qita = false;
      } else {
        this.cRun_qita = true;
      }
    },
    // 年份选择
    cYearDate(val) {},
    // 员工规模
    cPeoplesSelect(val) {},
    // 参展状态一级select
    cExhibitionSelect(val) {
      let childSelect = this.statusList.filter((res) => {
        return res.sta === val;
      });
      let arr = [];
      childSelect[0].children.forEach((el, index) => {
        arr[index] = {
          label: el,
          value: el,
        };
      });
      this.optionsChild = arr;
    },
    // 参展状态二级select
    cExhibitionChildSelect(val) {
      this.form.cExhibition = val;
    },

    // 产品类型一级select
    cProductSelect(val) {
      this.parentTypeId = val;
      let childrenSelect = this.productList.filter((res) => {
        return res.id === val;
      });
      let arr = [];
      childrenSelect[0].children.forEach((el, index) => {
        arr[index] = {
          label: el.name,
          value: el.id,
          isCheck: false,
        };
      });
      this.cProduct_childOptions = arr;
    },
    // 产品类型二级select  val是下拉框选择多选时的list
    cProductChildSelect(val) {
      this.childTypeId = val;
      this.cProduct_childOptions.forEach((res) => {
        res.isCheck = false;
      });
      val.forEach((res) => {
        this.cProduct_childOptions.forEach((el) => {
          if (res === el.value) {
            el.isCheck = true;
          }
        });
      });
    },
    // 产品类型的其他
    handleChecbox(val) {
      if (val) {
        this.checkSelect_qita = false;
      } else {
        this.checkSelect_qita = true;
      }
    },

    // 编辑 | 保存
    onNext() {
      if (this.initInputStatus) {
        this.initInputStatus = false;
        this.initRadioAndUploadImg = true;
        this.$http.get("userInfo").then((response) => {
          let { code, user } = response.data;
          this.fileList.push({
            name: user.cLicense.slice(18),
          });
          this.form.cLicense = user.cLicense;
          this.logoImageUrl = user.cLogo;
          this.form.cLogo = user.cLogo;
          this.form.cType = user.cType;
          this.form.cRun = user.cRun;
          this.form.cPeoples = user.cPeoples;
          this.form.cExhibition = user.cExhibition;
          this.cProduct_childOptions = user.productNameList;
          this.cqrImageUrl = user.cQr;
          this.form.cQr = user.cQr;
          this.form.cEnglishIntroduction = user.cEnglishIntroduction;
          this.form.cEnglishAddres = user.cEnglishAddres;
          let seles = JSON.parse(user.cProduct);
          let subset = JSON.parse(seles.subset);
          this.cProductSelect(seles.parent); // 使主营产品类型select可以正确显示值
          this.cProductChildSelect(subset); // 使主营产品类型select可以正确显示值
          let childrenSelect = this.productList.filter((res) => {
            return res.id === seles.parent;
          });
          this.form.cProduct = childrenSelect[0].name; // 点击编辑时进行的赋值
          this.form.cProduct_child = subset; // 点击编辑时进行的赋值
        });
      } else {
        let formatProduct =  JSON.stringify({
          parent: this.parentTypeId,
          subset: JSON.stringify(this.childTypeId),
          remarks: this.checkSelect_qita_input,
        });
        this.$http({
          url: "accountUpdate",
          method: "post",
          data: this.$http.adornData({
            id: this.form.id,
            pName: this.form.pName, // 姓名
            pJob: this.form.pJob, // 职位
            pLandline: this.form.pLandline, // 座机
            pEmail: this.form.pEmail, // 邮箱
            // 企业信息
            cName: this.form.cName, // 公司名称
            cEnglishName: this.form.cEnglishName, // 公司名称（英文）
            cLicense: this.form.cLicense, // 营业执照
            cLogo: this.form.cLogo, // 公司logo
            cAddress: this.form.cAddress, // 详细地址
            cEnglishAddres: this.form.cEnglishAddres, // 地址（英文）
            cWebsite: this.form.cWebsite, // 网址
            cType: this.cType_qita ? this.form.cType : this.form.cType_qit, // 企业类型
            cRun: this.cRun_qita ? this.form.cRun : this.form.cRun_qit, // 运作模式
            cManey: this.form.cManey, // 注册资本
            cPerson: this.form.cPerson, // 法人代表
            cYear: this.form.cYear, // 成立年份
            cPeoples: this.form.cPeoples, // 员工规模
            cIntroduction: this.form.cIntroduction, // 公司简介
            cEnglishIntroduction: this.form.cEnglishIntroduction, // 公司简介（英文）
            cExhibition: this.form.cExhibition, // 参展状态
            cProduct: formatProduct, // 产品类型
            cQr: this.form.cQr, // 二维码
          }),
        }).then(({ data }) => {
          let { code, msg } = data;
          if (code === 0) {
            this.initInputStatus = true;
            this.initRadioAndUploadImg = false;
            this.$message.success(msg);
            this.eventUserInfo();
          }
        }).catch(err => console.log(err))
      }
    },
  },
};
</script>
<style lang="scss">
.exinformation {
  .gsjj {
    .el-textarea__inner {
      height: 100%;
    }
  }
  .rihtDpi {
    float: right;
    margin: 121px 460px 0 0;
    color: #999999;
  }
  .el-upload-list {
    width: 500px;
  }
  .el-radio__input .el-radio__inner {
    width: 20px;
    height: 20px;
  }
  .el-radio__input.is-checked .el-radio__inner {
    width: 20px;
    height: 20px;
    background-color: #ffffff;
    border: 2px solid #dcdfe6;
    border-color: #143372;
  }
  .el-radio__inner {
    &:hover {
      border-color: #143372;
    }
  }
  .el-radio__inner::after {
    width: 12px;
    height: 12px;
    background-color: #143372;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #333333;
  }
}
.select_qita {
  .el-input__inner {
    height: 30px;
    line-height: 30px;
    margin-top: 7.5px;
    border-radius: 0;
    width: 300px;
  }
}
</style>
<style lang="scss" scoped>
.exinformation {
  min-height: 2783px;
  .title {
    width: 100%;
    height: 66px;
    line-height: 66px;
    font-size: 18px;
    color: #143372;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    text-indent: 30px;
    margin-bottom: 10px;
    p {
      width: 70px;
      height: 2px;
      background-color: #143372;
      position: absolute;
      bottom: -1px;
      left: 30px;
    }
  }
  .register_1 {
    // width: 955px;
    // height: 3219px;
    // margin: 0 auto;
    .el-input {
      width: 624px;
    }
    .lxr {
      p:first-child {
        height: 15px;
        line-height: 15px;
        margin-bottom: 9px;
        font-size: 15px;
        color: #333333;
        height: 14px;
        margin-left: 30px;
        float: left;
      }
      p:last-child {
        width: 66px;
        float: right;
        font-size: 14px;
        line-height: 14px;
        margin-right: 5px;
        color: #999999;
        margin-right: 30px;
        span {
          color: red;
        }
      }
    }

    .register-form {
      .el-form-item {
        margin: 22px 0;
      }
      .upload-demo {
        .el-button--default {
          width: 150px;
          height: 42px;
          background-color: #143372;
          color: #ffffff;
        }
        .el-upload__tip {
          height: 14px;
          line-height: 14px;
          font-size: 14px;
          color: #999999;
        }
      }
      .el-radio {
        display: block;
        line-height: 3;
      }
      .radio_input {
        width: 512px;
        height: 42px;
        margin-left: 20px;
        .el-input__inner {
          height: 42px !important;
        }
      }
      .zczb {
        width: 512px;
        margin-right: 24px;
      }
      .clnf {
        width: 110px;
        margin-right: 21px;
      }
      .gsjj {
        width: 624px;
        height: 300px;
      }
      .posi {
        position: relative;
        .desc {
          position: absolute;
          right: 160px;
          bottom: 5px;
          font-size: 14px;
          color: #bbbbbb;
          height: 20px;
          line-height: 20px;
        }
      }
      .czzt {
        width: 290px;
        margin-right: 30px;
      }
      .czzt_2 {
        width: 213px;
      }
      .yggm_type {
        width: 237px;
        margin-right: 30px;
      }
      .yggm_ly {
        width: 345px;
      }
    }
  }

  .next {
    margin: 80px 0 104px 382px;
    width: 220px;
    height: 54px;
    background-color: #143372;
    font-size: 18px;
    color: #ffffff;
  }
  .zhanshiText {
    color: #333333;
    font-size: 14px;
  }
  .zhanshiLogoImg {
    width: 150px;
    height: 150px;
    border-radius: 5px;
  }
  .zhanshiLicenseImg {
    width: 148px;
    height: 202px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
  }
}
</style>